/**
 * signInOutcome: what one finished sign in means, decided in one place for
 * every door (phone, email, Google).
 *
 * A sign in that CREATED the account is a sign up: it is logged as
 * `sign_up`, and the stored referral code is cleared because the server has
 * attributed it to the new account (when it was valid). An Order together
 * link token is spent the same way, and noted so the join that follows knows
 * the account is new (utils/groupBasketLink.js). Anything else is a
 * `login`, and the code is kept for the account that may still be created.
 * Whether the account is new is the server's answer (`isNewUser`), never a
 * guess from which page the shopper signed in on.
 */
import { trackLogin, trackSignUp } from "./analytics";
import { clearReferralCode } from "./referralCode";
import { noteGroupLinkAccountCreated } from "./groupBasketLink";

export const recordSignInOutcome = ({ method, isNewUser }) => {
  if (isNewUser === true) {
    trackSignUp(method);
    clearReferralCode();
    noteGroupLinkAccountCreated();
    return;
  }
  trackLogin(method);
};

export default recordSignInOutcome;
